import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PostOfficeInfo } from '../interfaces/post-office-info.interface';
import { DisplayMessageToUserService } from '../services/display-to-user-message.service';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  private changedFieldsStates: { [key: string]: boolean | null; } = {};
  private fieldsChangedSubj: BehaviorSubject<{ [key: string]: boolean | null; }> = new BehaviorSubject<{ [key: string]: boolean | null; }>(null)
  private clearedFilters: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private selectedFreightSubject: BehaviorSubject<string> = new BehaviorSubject<string>('shippedFreightAll');
  private showRightColumnSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);


  constructor(
    private displayMessages: DisplayMessageToUserService,
  ) { }

  // Method to clear all filter states
  public clearAllFilters() {
    // Reset all filters
    this.changedFieldsStates = {};
    this.emitFieldsToSubscribers();
  }

  // Получаем текущее выбранное значение радио-батона
  public getSelectedFreight$() {
    return this.selectedFreightSubject.asObservable();
  }

  // Получаем текущее состояние отображения правой колонки
  public getShowRightColumn$() {
    return this.showRightColumnSubject.asObservable();
  }

  // Устанавливаем выбранное значение радио-батона
  public setSelectedFreight(value: string) {
    this.selectedFreightSubject.next(value);
    this.setShowRightColumn(value);
  }

  // Устанавливаем состояние отображения правой колонки
  private setShowRightColumn(selectedFreight: string) {
    this.showRightColumnSubject.next(selectedFreight !== 'shippedFreightVv');
  }

  public getSubjectFiltersAfterChange(): BehaviorSubject<{ [key: string]: boolean | null; }> {
    return this.fieldsChangedSubj;
  }

  public setFilterState(filterName: string, newState: boolean | null) {
    if (filterName) {
      this.changedFieldsStates[filterName] = newState;
      this.emitFieldsToSubscribers()
    }
  }

  public emitFieldsToSubscribers() {
    this.fieldsChangedSubj.next(Object.assign({}, this.changedFieldsStates))
  }

  public clearFilter(filterName: string) {
    this.clearedFilters.next(filterName);
  }

  public getClearedFilterSubject(): BehaviorSubject<string> {
    return this.clearedFilters;
  }


  // public filterOfficesByEnabledFilters(officesArray: Array<PostOfficeInfo>) {
  //   if (officesArray && officesArray.length) { // test if wasnt earlier
  //     // get filters
  //     let filtersNamesToApply = Object.keys(this.changedFieldsStates).filter(key => {
  //       return this.changedFieldsStates[key] == true;
  //     })
  //     // project filters to not filter by same prop twice or more
  //     let convertingProjectionTempObject = {};
  //     let convertedFieldsNames;

  //     filtersNamesToApply.forEach(filterName => {
  //       let eqvivalentKeyInObjectArray: Array<string> = this.convertFilterNameToOfficeKeyNamesArray(filterName);
  //       eqvivalentKeyInObjectArray.forEach(key => {
  //         if (key != '') // == ''  means that any postoffice pass
  //           convertingProjectionTempObject[key] = '' // write in object to make projection and delete dublicates
  //       })
  //     })

  //     convertedFieldsNames = Object.keys(convertingProjectionTempObject);

  //     // filter by projected props
  //     let officesThatLeftAfterFilter = officesArray;

  //     convertedFieldsNames.forEach(filterName => { // apply each filter
  //       if (filterName === 'TYPE_ACRONYM') {
  //         this.displayMessages.displayMessageOnMap(false);
  //         // Здесь фильтруем по TYPE_ACRONYM в зависимости от выбранного фильтра
  //         const selectedFreight = this.changedFieldsStates['shippedFreight'];
  //         if (this.changedFieldsStates['shippedFreightVv']) {
  //           officesThatLeftAfterFilter = officesThatLeftAfterFilter.filter(office => office.TYPE_ACRONYM === 'ВВ');
  //         } else if (this.changedFieldsStates['shippedFreightMv']) {
  //           officesThatLeftAfterFilter = officesThatLeftAfterFilter.filter(office => office.TYPE_ACRONYM === 'МВ');
  //         } else if (this.changedFieldsStates['shippedFreightPm']) {
  //           officesThatLeftAfterFilter = officesThatLeftAfterFilter.filter(office => office.TYPE_ACRONYM === 'П-т');
  //         }
  //       } else {
  //         officesThatLeftAfterFilter = this.filterOfficesByfiltersKeyWithValue(officesThatLeftAfterFilter, filterName, true);
  //       }
  //       let startOfficesList = officesThatLeftAfterFilter;

  //       if (filterName != '') { // if empty key output all offices
  //         startOfficesList = this.filterOfficesByfiltersKeyWithValue(startOfficesList, filterName, true)
  //         startOfficesList = this.filterOfficesByTimeFilters(startOfficesList, filterName);
  //       }

  //       officesThatLeftAfterFilter = startOfficesList;

  //       if (!officesThatLeftAfterFilter || officesThatLeftAfterFilter.length === 0) // !officesThatLeftAfterFilter ||
  //         return []
  //     })

  //     return officesThatLeftAfterFilter;
  //   } else { // also wasnt
  //     return []
  //   }

  // }


  // NEW FUNCTION START
  public filterOfficesByEnabledFilters(officesArray: Array<PostOfficeInfo>) {
    if (!officesArray || !officesArray.length) return [];

    let filtersNamesToApply = Object.keys(this.changedFieldsStates).filter(key => {
      return this.changedFieldsStates[key] == true;
    });

    let officesThatLeftAfterFilter = officesArray;

    filtersNamesToApply.forEach(filterName => {
      let equivalentKeys = this.convertFilterNameToOfficeKeyNamesArray(filterName);

      equivalentKeys.forEach(key => {
        if (key === '') return;

        if (['TYPE_ACRONYM', 'CARGO', 'IS_POSHTOMAT', 'IS_PUDO'].includes(key)) {
          this.displayMessages.displayMessageOnMap(false);

          switch (filterName) {
            case 'shippedFreightMv':
              // SWITCH TYPE_ACRONYM for a new attribute if needed
              officesThatLeftAfterFilter = officesThatLeftAfterFilter.filter(o => o.TYPE_ACRONYM === 'МВ');
              break;
              
            case 'shippedFreightVv':
              // Вантажні тепер через CARGO
              officesThatLeftAfterFilter = officesThatLeftAfterFilter.filter(o => o[key] == '1');
              break;

            case 'shippedFreightPm':
              // Поштомати через IS_POSHTOMAT
              officesThatLeftAfterFilter = officesThatLeftAfterFilter.filter(o => o[key] == '1');
              break;

            case 'shippedFreightPudo':
              // Точки видачі через IS_PUDO
              officesThatLeftAfterFilter = officesThatLeftAfterFilter.filter(o => o[key] == '1');
              break;
              
            // shippedFreightAll — нічого не фільтруємо, показуємо все
          }
        } else {
          // Логіка для всіх інших фільтрів (чекбокси послуг)
          officesThatLeftAfterFilter = this.filterOfficesByfiltersKeyWithValue(officesThatLeftAfterFilter, key, true);
          officesThatLeftAfterFilter = this.filterOfficesByTimeFilters(officesThatLeftAfterFilter, key);
        }
      });
    });

    return officesThatLeftAfterFilter;
  }
  // NEW FUNCTION END
  
  public isInSchadulePresentDaysOff(schadule: Array<any>, needBoth: boolean = false): boolean {

    if (schadule && schadule.length) {
      let daysOff = schadule.filter((day: any) => {
        return (day.DAYOFWEEK_NUM == 6 || day.DAYOFWEEK_NUM == 7) // needBoth
      })
      return !!(daysOff.length)
    } else {
      return false;
    }
  }

  public filterOfficesByTimeFilters(officesArray: Array<PostOfficeInfo>, key: string) {

    if (officesArray && officesArray.length) {

      let resultOffices = [];

      //for (let i = 0; i < officesArray.length; i++) {
      resultOffices = officesArray.filter((office: any) => {

        switch (key) {
          // check current office
          case "openedAtDaysOff":
            return this.isInSchadulePresentDaysOff(office.schedule, false);
            break;
          // case "shippedFreight":
          //   return this.isShippedFreight(office);
          //   break;
          case "nowOpened":
            return this.isOpenedNowBySchadule(office.schedule);
            break;
          case "sevenDayOnWeek":
            return this.isSevenDayOnWeek(office.schedule);
            break;
          case "openedAfter19hours":
            return this.isOpenedAfter19TodayBySchadule(office.schedule);
            break;
          default:
            return officesArray; //for filters which not exist at all or its filter not by time
            break;
        }
      })
      return resultOffices;
      //}

    } else {
      return [];
    }

  }

  public isOpenedAfter19TodayBySchadule(schadule: Array<any>): boolean {
    if (schadule && schadule.length) {

      var d = new Date();
      var n = d.getDay();

      let currentDay: any = schadule.filter(day => {
        return (-(-day.DAYOFWEEK_NUM) == n);
      });
      if (!currentDay || currentDay.length == 0)
        return false;

      let to: string = currentDay[0]['TTO'].split(':');
      if (-(-to[0]) < 19)
        return false;
      if (-(-to[0]) >= 20)
        return true;
      if (-(-to[1]) > 0) // hours == 19 check mins
        return true;

      return false;
    } else {
      return false;
    }
  }

  public isSevenDayOnWeek(schadule: Array<any>): boolean {

    if (schadule && schadule.length == 7) {

     var d = new Date();
      var n = d.getDay();

      let currentDay: any = schadule.filter(day => {
        return (-(-day.DAYOFWEEK_NUM) == n);
      });
      if (!currentDay || currentDay.length == 0)
        return false;

      return true;
    }
    return false;
  }


  public isOpenedNowBySchadule(schadule: Array<any>): boolean {

    if (schadule && schadule.length) {

      var d = new Date();
      var n = d.getDay();
      var h = d.getHours();
      var m = d.getMinutes();


      let currentDay: any = schadule.filter(day => {
        return (-(-day.DAYOFWEEK_NUM) == n);
      });

      if (!currentDay || currentDay.length == 0)
        return false;

      let from: string = currentDay[0]['TFROM'].split(':'); // 0 -hours , 1 - minutes
      let to: string = currentDay[0]['TTO'].split(':');

      // compare by working time
      // compare by hours
      if (-(- from[0]) > h || -(- to[0]) < h) // before open after close
        return false;

      // compare by minutes
      if (-(- from[0]) == h && -(- from[1]) > m || -(- to[0]) == h && -(- to[1]) < m)
        return false;

      // compare by break time

      if (currentDay[0]['BREAKTFROM'] && currentDay[0]['BREAKTTO']) { // if both defined
        let breakFrom: string = currentDay[0]['BREAKTFROM'].split(':');
        let breakTo: string = currentDay[0]['BREAKTTO'].split(':');

        // compare by hours
        if (-(- breakFrom[0]) < h && -(- breakTo[0]) > h) // before open after close
          return false;

        // compare by minutes
        if (-(- breakFrom[0]) == h && -(- breakFrom[1]) < m || -(- breakTo[0]) == h && -(- breakTo[1]) > m)
          return false;

      }
      return true;
    }
    return false;
  }

  public isBreakTimeNowBySchadule(schadule: Array<any>): boolean {

    if (schadule && schadule.length) {

      var d = new Date();
      var n = d.getDay();
      var h = d.getHours();
      var m = d.getMinutes();


      let currentDay: any = schadule.filter(day => {
        return (-(-day.DAYOFWEEK_NUM) == n);
      });

      if (!currentDay || currentDay.length == 0)
        return false;

      /*let from: string = currentDay[0]['TFROM'].split(':'); // 0 -hours , 1 - minutes
      let to: string = currentDay[0]['TTO'].split(':');

      // compare by working time
      // compare by hours
      if (-(- from[0]) > h || -(- to[0]) < h) // before open after close
        return false;

      // compare by minutes
      if (-(- from[0]) == h && -(- from[1]) > m || -(- to[0]) == h && -(- to[1]) < m)
        return false;
      */
      // compare by break time

      if (currentDay[0]['BREAKTFROM'] && (typeof currentDay[0]['BREAKTFROM'] == 'string') && currentDay[0]['BREAKTFROM'].length > 4 && currentDay[0]['BREAKTTO'] && (typeof currentDay[0]['BREAKTTO'] == 'string') && currentDay[0]['BREAKTTO'].length > 4) { // if both defined
        let breakFrom: Array<string> = currentDay[0]['BREAKTFROM'].split(':');
        let breakTo: Array<string> = currentDay[0]['BREAKTTO'].split(':');

        // compare by hours
        if (-(- breakFrom[0]) <= h && -(- breakTo[0]) > h)
          return true;

        // compare by minutes
        if (-(- breakFrom[0]) == h && -(- breakFrom[1]) <= m || -(- breakTo[0]) == h && -(- breakTo[1]) >= m)
          return true;

        return false;
      } else {
        // break not defined == now not break
        return false;
      }
    }
    return false; /// no schadule == now not break
  }

  public filterOfficesByfiltersKeyWithValue(officesArray: Array<PostOfficeInfo>, key: string, expectedValue: boolean) {
    if (key == 'sevenDayOnWeek' || key == 'openedAfter19hours' || key == 'openedAtDaysOff' || key == 'nowOpened' || key == 'TYPE_ACRONYM')
      return officesArray;

    let filtered = [];

    if (officesArray && key && expectedValue == true) {
      // database return strings but '0' - office haven`t feature , '1' - does
      // in logic equation  both not empty string  so both are     true

      filtered = officesArray.filter(office => {
        return (office[key] == '1' || office[key] == '2');

      })

      return filtered;
    } else {
      return officesArray;
    }

  }


  public getCurrentDayNumber() {
    var d = new Date();
    var n = d.getDay();
    return n;
  }

  public getCurrentMinutes() {
    var d = new Date();
    var m = d.getMinutes();
    return m;
  }

  public getCurrentHours() {
    var d = new Date();
    var h = d.getHours();
    return h;
  }

  public isOfficeOpenedNow(workFrom, workTo, breakFrom = null, breakTO = null) {
    // need rework copypaste from huge method
    var d = new Date();
    var h = d.getHours();
    var m = d.getMinutes();

    if (h < -(-workFrom) || h > -(-workTo))
      return false;

    return true;
  }


  public convertFilterNameToOfficeKeyNamesArray(checkboxFilterName: string): Array<string> {
    // if empty string -   ['']    - means that all offices are pass by this filter
    switch (checkboxFilterName) {
      case 'cashRecievingFromCard':
        return ['IS_CASH'];
        break;
      case 'businessPriority':
        return [''];
        break;
      // case 'expressDeliveryDHL':
      //   return ['IS_DHL'];
      //   break;
      case 'prepayNewspaper':
        return [''];
        break;
      case 'hurryPaymentTransfer':
        return ['PELPEREKAZY'];
        break;
      case 'happyHurryPaymentTransfer':
        return ['IS_HAPPY_HOURS'];
        break;
      case 'EXPRESS':
        return ['IS_AUTOMATED'];
        break;
      case 'openedAfter19hours':
        return ['openedAfter19hours'];
        break;
      case 'openedAtDaysOff':
        return ['openedAtDaysOff'];
        break;
      case 'paymentTransferInForeignCurrency':
        return [''];
        break;
      case 'SMARTBOX':
        return ['IS_AUTOMATED', 'IS_SMARTBOX'];
        break;
      case 'sevenDayOnWeek':
        return ['sevenDayOnWeek'];
        break;
      case 'shippedFreightAll':
        return ['TYPE_ACRONYM'];
        break;
      case 'shippedFreightVv':
        return ['CARGO'];
        break;
      case 'shippedFreightMv':
        return ['TYPE_ACRONYM'];
        break;
      case 'cargoDelivery':
        return ['CARGO']
        break;
      // NEW FILTERS START
      case 'shippedFreightPm':
        return ['IS_POSHTOMAT'];
        break;
      case 'shippedFreightPudo':
        return ['IS_PUDO'];
        break;
      // NEW FILTERS END
      case 'nowOpened':
        return ['nowOpened'];
        break;
      case 'shippedOffAtSameDay':
        return ['IS_FLAGMAN'];
        break;
      case 'communalPayments':
        return ['']
        break;
      case 'interationalDelivery':
        return ['']
        break;
      case 'urgentTransrers':
        return ['URGENT_TRANSFERS']
        break;
      case 'onlineShopping':
        return ['']
        break;
      default:
        return [''];
        break;
    }


  }






}
